(function ($) {
  'use strict';

  /* Podcast video cards (.pc-card): click the poster to load a YouTube player
     via the IFrame API. Only one video plays at a time - when any player
     starts, every other one is paused. Shared by /education/podcasts/ and the
     About Us slider. Cards inside a [data-pc-mode="modal"] container (About Us)
     and the Glimpses Shorts (.pc-glimpse) open in a centred modal (#pc-modal)
     instead of playing inline. */

  var players = [];
  var apiLoading = false;
  var apiQueue = [];

  function withYouTubeApi(callback) {
    if (window.YT && window.YT.Player) {
      callback();
      return;
    }
    apiQueue.push(callback);
    if (apiLoading) return;
    apiLoading = true;

    var previousReady = window.onYouTubeIframeAPIReady;
    window.onYouTubeIframeAPIReady = function () {
      if (typeof previousReady === 'function') previousReady();
      apiQueue.splice(0).forEach(function (fn) { fn(); });
    };

    var tag = document.createElement('script');
    tag.src = 'https://www.youtube.com/iframe_api';
    document.head.appendChild(tag);
  }

  function pauseOthers(current) {
    players.forEach(function (player) {
      if (player !== current && typeof player.pauseVideo === 'function') player.pauseVideo();
    });
  }

  function startCard($card) {
    var existing = $card.data('pcPlayer');
    if (existing) {
      existing.playVideo();
      return;
    }

    var $frame = $card.find('.pc-card__frame');
    if ($frame.hasClass('is-loading')) return;
    var $mount = $('<div class="pc-card__mount"></div>');
    $frame.addClass('is-loading').append($mount);

    withYouTubeApi(function () {
      var player = new window.YT.Player($mount[0], {
        host: 'https://www.youtube-nocookie.com',
        videoId: $card.attr('data-video-id'),
        playerVars: { autoplay: 1, rel: 0, playsinline: 1, modestbranding: 1 },
        events: {
          onReady: function (e) {
            $frame.removeClass('is-loading').addClass('is-live');
            e.target.playVideo();
          },
          onStateChange: function (e) {
            var state = window.YT.PlayerState;
            if (e.data === state.PLAYING) {
              pauseOthers(e.target);
              $card.addClass('is-playing');
            } else if (e.data === state.PAUSED || e.data === state.ENDED) {
              $card.removeClass('is-playing');
            }
          }
        }
      });
      $card.data('pcPlayer', player);
      players.push(player);
    });
  }

  /* ---------- Modal (full episodes on About Us, Shorts on Podcasts) ---------- */
  var $modal = $('#pc-modal');
  var $stage = $modal.find('.pc-modal__stage');
  var $full = $modal.find('.pc-modal__full');
  var modalPlayer = null;
  var lastTrigger = null;
  var openSeq = 0;
  var glSwiper = null;
  var $navBtns = $modal.find('.pc-modal__nav');

  /* opts: { id, title, trigger, portrait, fullId, fullTitle, keepFocus, nav } */
  function openModal(opts) {
    var seq = ++openSeq;
    if (modalPlayer && typeof modalPlayer.destroy === 'function') modalPlayer.destroy();
    modalPlayer = null;
    lastTrigger = opts.trigger;
    $navBtns.prop('hidden', !opts.nav);
    $modal.toggleClass('is-portrait', !!opts.portrait);
    $modal.find('.pc-modal__title').text(opts.title);
    $modal.find('.pc-modal__from').text(opts.fullTitle ? 'From: ' + opts.fullTitle : '');
    $modal.find('.pc-modal__yt').attr('href', 'https://www.youtube.com/watch?v=' + opts.id);
    if (opts.fullId) {
      $full.attr({ href: 'https://www.youtube.com/watch?v=' + opts.fullId, 'data-full-id': opts.fullId }).prop('hidden', false);
    } else {
      $full.removeAttr('data-full-id').prop('hidden', true);
    }
    $stage.empty().addClass('is-loading');
    var $mount = $('<div class="pc-modal__mount"></div>');
    $stage.append($mount);
    $modal.addClass('open').attr('aria-hidden', 'false');
    $('body').css('overflow', 'hidden');
    if (!opts.keepFocus) $modal.find('.pc-modal__close').trigger('focus');

    withYouTubeApi(function () {
      if (seq !== openSeq || !$modal.hasClass('open')) return;
      pauseOthers(null);
      modalPlayer = new window.YT.Player($mount[0], {
        host: 'https://www.youtube-nocookie.com',
        videoId: opts.id,
        playerVars: { autoplay: 1, rel: 0, playsinline: 1, modestbranding: 1 },
        events: {
          onReady: function (e) {
            $stage.removeClass('is-loading');
            e.target.playVideo();
          }
        }
      });
    });
  }

  function closeModal(skipFocus) {
    if (!$modal.hasClass('open')) return;
    openSeq++;
    $modal.removeClass('open').attr('aria-hidden', 'true');
    $('body').css('overflow', '');
    if (modalPlayer && typeof modalPlayer.destroy === 'function') modalPlayer.destroy();
    modalPlayer = null;
    $stage.empty();
    if (lastTrigger && !skipFocus) $(lastTrigger).trigger('focus');
  }

  /* ---------- Glimpses slider: Shorts cut from the podcasts ---------- */
  function initGlimpsesSlider() {
    if (!window.Swiper || !$('#pc-gl-swiper').length) return;
    glSwiper = new window.Swiper('#pc-gl-swiper', {
      slidesPerView: 1.4,
      spaceBetween: 14,
      grabCursor: true,
      watchOverflow: true,
      breakpoints: {
        480: { slidesPerView: 2.2 },
        720: { slidesPerView: 3.2, spaceBetween: 16 },
        1000: { slidesPerView: 4, spaceBetween: 20 }
      },
      navigation: { nextEl: '#pc-gl-next', prevEl: '#pc-gl-prev', disabledClass: 'swiper-button-disabled' },
      pagination: { el: '#pc-gl-progress', type: 'progressbar' }
    });
  }

  /* Open a Short in the modal; step through the others with Previous / Next (wraps around). */
  function openGlimpse(index, keepFocus) {
    var $all = $('.pc-glimpse');
    if (!$all.length) return;
    index = (index + $all.length) % $all.length;
    var $g = $all.eq(index);
    openModal({
      id: $g.attr('data-video-id'),
      title: $g.attr('data-title'),
      fullId: $g.attr('data-full-id'),
      fullTitle: $g.attr('data-full-title'),
      portrait: true,
      nav: $all.length > 1,
      keepFocus: keepFocus,
      trigger: $g[0]
    });
    /* Keep the slider behind the modal on the Short being watched. */
    if (glSwiper) {
      var slide = $g.closest('.swiper-slide').index();
      if (slide > -1) glSwiper.slideTo(slide);
    }
    $modal.data('glIndex', index);
  }

  $(function () {
    initGlimpsesSlider();

    $(document).on('click', '.pc-card__play', function () {
      var $card = $(this).closest('.pc-card');
      if ($modal.length && $card.closest('[data-pc-mode="modal"]').length) {
        openModal({
          id: $card.attr('data-video-id'),
          title: $card.find('.pc-card__title').text(),
          trigger: this
        });
      } else {
        startCard($card);
      }
    });

    $(document).on('click', '.pc-glimpse', function () {
      openGlimpse($('.pc-glimpse').index(this), false);
    });

    $modal.on('click', '.pc-modal__nav', function () {
      var step = $(this).hasClass('pc-modal__nav--next') ? 1 : -1;
      openGlimpse(($modal.data('glIndex') || 0) + step, true);
    });

    /* "Watch Full Podcast": if the episode is on this page, close the modal,
       scroll to its card and start it; otherwise the link opens YouTube. */
    $full.on('click', function (e) {
      var $target = $('.pc-card[data-video-id="' + $(this).attr('data-full-id') + '"]').first();
      if (!$target.length) return;
      e.preventDefault();
      closeModal(true);
      $('html, body').animate({ scrollTop: Math.max(0, $target.offset().top - 120) }, 450);
      startCard($target);
    });

    $modal.on('click', function (e) {
      if (e.target === this) closeModal();
    });
    $modal.find('.pc-modal__close').on('click', function () { closeModal(); });
    $(document).on('keydown', function (e) {
      if (e.key === 'Escape') closeModal();
      if ($modal.hasClass('open') && !$navBtns.first().prop('hidden')) {
        if (e.key === 'ArrowRight') $navBtns.filter('.pc-modal__nav--next').trigger('click');
        if (e.key === 'ArrowLeft') $navBtns.filter('.pc-modal__nav--prev').trigger('click');
      }
    });
  });
})(jQuery);
